import {
    accessedOnText,
    replyWithAttachmentLastModifiedText,
} from './getAttachmentSuggestionsMenuItems.locstring.json';
import {
    ReplyWithAttachmentSuggestion,
    ReplyWithEndpointType,
} from '../store/schema/AttachmentSuggestions';
import { logUsage } from 'owa-analytics';
import { formatPastRelativeDateTime, formatUserDateTime, owaDate, OwaDate } from 'owa-datetime';
import loc, { format } from 'owa-localize';
import { observableNow } from 'owa-observable-datetime';

export function getAttachmentAccessDate(suggestion: ReplyWithAttachmentSuggestion): string {
    if (
        suggestion.Endpoint === ReplyWithEndpointType.MRUClassic ||
        suggestion.Endpoint === ReplyWithEndpointType.MRUClassicContextual
    ) {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (22,9): Type 'null' is not assignable to type 'string'.
        // @ts-expect-error
        return null;
    } else {
        const { DateAccessed: dateAccessed } = suggestion;

        if (!dateAccessed) {
            // For files in cloud this can happen if user received a file which has
            // org/anonymous link and user hasn't opened the file. As for ODSP user
            // gets ACLed to file only after they open it in such cases, hence we get
            // suggestions for files missing this data because the service can't access
            // it yet on behalf of user. Once user is ACLed these properties next time
            // should have values.
            logUsage('AttachmentSuggestionNoAccessDate', undefined, {
                cosmosOnlyData: JSON.stringify({ suggestionId: suggestion.Id }),
                excludeFromKusto: true,
            });

            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2322 (41,13): Type 'null' is not assignable to type 'string'.
            // @ts-expect-error
            return null;
        }

        const date: OwaDate = owaDate('UTC', dateAccessed);
        const dateAccessedText = formatPastRelativeDateTime(date, observableNow());

        return format(loc(accessedOnText), dateAccessedText);
    }
}

export function getModifiedDate(suggestion: ReplyWithAttachmentSuggestion): string {
    const { DateModified: dateModified } = suggestion;

    if (!dateModified) {
        // For files in cloud this can happen if user received a file which has
        // org/anonymous link and user hasn't opened the file. As for ODSP user
        // gets ACLed to file only after they open it in such cases, hence we get
        // suggestions for files missing this data because the service can't access
        // it yet on behalf of user. Once user is ACLed these properties next time
        // should have values.
        logUsage('AttachmentSuggestionNoModifiedDate', undefined, {
            cosmosOnlyData: JSON.stringify({ suggestionId: suggestion.Id }),
            excludeFromKusto: true,
        });

        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (69,9): Type 'null' is not assignable to type 'string'.
        // @ts-expect-error
        return null;
    }

    const date: OwaDate = owaDate('UTC', dateModified);
    const lastModifiedDateText: string = formatUserDateTime(date);

    return format(loc(replyWithAttachmentLastModifiedText), lastModifiedDateText);
}
